import { observer } from 'mobx-react-lite'
import { type WorkspaceSignupViewModel } from '@/features/iam/workspaces/WorkspaceSignup/WorkspaceSignupViewModel'
import { WorkspaceSearchView } from '@/features/iam/workspaces/components/WorkspaceSearchView'
import { SignupTextInput } from '@/features/iam/workspaces/components/SignupTextInput'
import { env } from '@/infra/env'

export interface WorkspaceSearchViewContainerProps {
  vm: WorkspaceSignupViewModel
}

export const WorkspaceSearchViewContainer = observer(
  function WorkspaceSearchViewContainer({
    vm,
  }: WorkspaceSearchViewContainerProps) {
    return (
      <WorkspaceSearchView
        canContinue={vm.canSearchWorkspace}
        onContinue={vm.search}
      >
        <SignupTextInput
          staticText={`.${env.ORIGIN_WORTAL}`}
          label="Workspace Slug"
          error={vm.slugError}
          isDisabled={vm.searchWorkspace.pending}
          value={vm.slug}
          onChange={vm.setSlug}
          placeholder="Workspace"
        />
      </WorkspaceSearchView>
    )
  },
)
